import React from 'react';
import './loader.css'; // Import CSS for styling

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
